import { NavLink, useLocation } from "react-router-dom";

export default function CustomNavLink({ to, children, ...props }){
  const location = useLocation();
  const isActive = location.pathname === to;

  const handleClick = (e) => {
    if (isActive) {
      e.preventDefault(); // prevent navigation if already active
    }
  };

  return (
    <NavLink to={to} onClick={handleClick} {...props}>
      {children}
    </NavLink>
  );
};
